import { Application } from "@hotwired/stimulus";
import PasswordVisibility from "@stimulus-components/password-visibility";
import Dialog from "@stimulus-components/dialog";

const application = Application.start();

application.register("password-visibility", PasswordVisibility);

application.register("dialog", Dialog);

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

export { application };
